import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE, ARTICLE_TAB } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const ARTICLE_ACTION_TYPES = {
	GET_ARTICLES_SUCCESS: 'GET_ARTICLES_SUCCESS',
    POST_ARTICLE_SUCCESS: 'POST_ARTICLE_SUCCESS',
    PUT_ARTICLE_SUCCESS: 'PUT_ARTICLE_SUCCESS',
    DELETE_ARTICLE_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_ARTICLES_PAGINATION: 'UPDATE_ARTICLES_PAGINATION'
};

const ARTICLES_URL = `${ENTRYPOINT}${API_ROUTES.ARTICLES}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getArticles = (data = { page: 0, rowsPerPage: 10, filters: { }}) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_ARTICLES_URL = `${ARTICLES_URL}${params}`;
        const response = await getData(GET_ARTICLES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: ARTICLE_ACTION_TYPES.GET_ARTICLES_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: ARTICLE_ACTION_TYPES.UPDATE_ARTICLES_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getArticle = async (uuid) => {
    const GET_ARTICLE_URL = `${ARTICLES_URL}/${uuid}`;
    return await getData(GET_ARTICLE_URL, getHeaders());
}

export const postArticle = (data) => {
    return async (dispatch) => {
        const response = await postData(ARTICLES_URL, data);
        dispatch({ type: ARTICLE_ACTION_TYPES.POST_ARTICLE_SUCCESS, payload: response });
        return history.push(REACT_ROUTES.ARTICLE_TABS, { selectedTab: ARTICLE_TAB });
    }
}

export const putArticle = (uuid, data) => {
    return async (dispatch) => {
        const PUT_ARTICLE_URL = `${ARTICLES_URL}/${uuid}`;
        const response = await putData(PUT_ARTICLE_URL, data);
        dispatch({ type: ARTICLE_ACTION_TYPES.PUT_ARTICLE_SUCCESS, payload: response });
        history.push(REACT_ROUTES.ARTICLE_TABS, { selectedTab: ARTICLE_TAB });
    }
}

export const deleteArticle = (uuid) => (
    async () => {
        const DELETE_ARTICLE_URL = `${ARTICLES_URL}/${uuid}`;
        await deleteData(DELETE_ARTICLE_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateArticlesPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: ARTICLE_ACTION_TYPES.UPDATE_ARTICLES_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getArticles({ page, rowsPerPage, filters }));
    }
}

